import { TerminalReplay } from "../terminal-replay";
import type { ConceptContentData } from "../types";
import { ConceptCodeBlock, ConceptText } from "./components";

type MakefileDiscoveryContent = Extract<
  ConceptContentData,
  { slug: "makefile-discovery" }
>;

// Explain the two stages a bare Make invocation must pass before work begins.
//
export function MakefileDiscoveryConcept({
  content,
}: {
  content: MakefileDiscoveryContent;
}) {
  return (
    <div className="grid gap-8">
      <div
        className="grid scroll-mt-20 items-start gap-6 lg:grid-cols-[minmax(0,1fr)_minmax(20rem,1fr)]"
        id="default-names"
      >
        <div className="grid gap-4">
          {content.paragraphs.map((paragraph) => (
            <p key={paragraph} className="text-muted-foreground leading-7">
              <ConceptText text={paragraph} />
            </p>
          ))}
        </div>

        <ConceptCodeBlock
          caption={content.exampleCaption}
          lines={content.exampleLines}
        />
      </div>

      <TerminalReplay
        context={content.terminalReplay.context}
        steps={content.terminalReplay.steps}
        title={content.terminalReplay.title}
      />
    </div>
  );
}
